import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import FilterSingleSelectDropdown from "../../components/filterDropdown/FilterSingleSelectDropdown";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import { stockFilterStatusOptions } from "../../shared/utility";

export function ProductsViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState({
    data: [],
  });

  const [primaryCategories, setPrimaryCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const defaultFilters = {
    primaryCategory: { value: -1, label: "All Primary Categories" },
    subCategory: { value: -1, label: "All Subcategories" },
    stockStatus: { value: -1, label: "All" },
  };
  const [filters, setFilters] = useState(defaultFilters);
  const [showFilters, setShowFilters] = useState(false);

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getProducts = async function (search, page, filter) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
      filter: filter,
    };
    let callResult = await makePostApiCall(`products`, payload);
    setLoading(false);
    if (callResult.success) {
      setProducts(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal("Could not fetch products");
    }
  };

  const getPrimaryCategoriesForDropdown = async function () {
    let callResult = await makePostApiCall(`/products/categories/dropdown`);
    if (callResult.success) {
      setPrimaryCategories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const getSubCategoriesForDropdownByPrimary = async function (
    primaryCategoryId
  ) {
    let callResult = await makePostApiCall(
      `/products/subcategories/dropdown/${primaryCategoryId}`
    );
    if (callResult.success) {
      setSubCategories(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const resetSubCategoryFilter = () => {
    setFilters({
      ...filters,
      subCategory: { value: -1, label: "All Subcategories" },
    });
  };

  const resetFilters = () => {
    const filterReset = {
      primaryCategory: { value: -1, label: "All Primary Categories" },
      subCategory: { value: -1, label: "All Subcategories" },
    };
    setFilters(filterReset);

    setShowFilters(false);
    getProducts(null, 1, filterReset);
  };

  const filterComponents = [
    <FilterSingleSelectDropdown
      header="Primary Category"
      onChange={(value) =>
        setFilters({
          ...filters,
          primaryCategory: value,
        })
      }
      options={primaryCategories}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="primaryCategory"
      value={filters.primaryCategory}
    />,
    <FilterSingleSelectDropdown
      header="Subcategories"
      onChange={(value) =>
        setFilters({
          ...filters,
          subCategory: value,
        })
      }
      options={subCategories}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="subCategory"
      value={filters.subCategory}
    />,
    <FilterSingleSelectDropdown
      header="Stock status"
      onChange={(value) =>
        setFilters({
          ...filters,
          stockStatus: value,
        })
      }
      options={stockFilterStatusOptions}
      resetFilter={() => setFilters(defaultFilters)}
      valueName="stockStatus"
      value={filters.stockStatus}
    />,
  ];

  return {
    emptyModal,
    setEmptyModelOpen,
    getProducts,
    loading,
    products,
    setSlideOver,
    slideOver,
    filterComponents,
    resetFilters,
    showFilters,
    setShowFilters,
    filters,
    getPrimaryCategoriesForDropdown,
    getSubCategoriesForDropdownByPrimary,
    resetSubCategoryFilter,
  };
}
